import { Input, Select } from 'common/InputForm';
import { CustomModal } from 'components/modals/ModalBox';
import useButtonLoader from 'hooks/useButtonLoader';
import React, { useEffect, useState } from 'react'
import { addToCartApi } from 'services/user';

const MedicineType = ({ show, close, data, listing = () => { }, fetchMedicineList = () => { } }) => {
    const [input, setInput] = useState({ type: '', quantity: '' })
    const [error, setError] = useState({})
    const [buttonLoader, setButtonLoader] = useButtonLoader('Add');

    const isLoss = input?.type === 'LOOSE'

    useEffect(() => {
        if (show && !input.type) {
            setInput((prev) => ({
                ...prev,
                type: "STRIP",
            }));
        }
    }, [show, data, input.type]);


    // ---------validation-----------
    const validation = () => {
        let status = true;
        let errorMessage = {};

        if (!input?.type) {
            errorMessage["type"] = "Please select medicine type";
            status = false;
        }
        if (isLoss && !input?.quantity) {
            errorMessage["quantity"] = "Please enter quantity";
            status = false;
        }
        setError(errorMessage);
        return status;
    };

    // console.log({ isLoss, input, data })

    const handleSubmit = () => {
        if (validation()) {
            handleAddToCart(
                data?.userId,
                data?.productId,
                data?.variantId,
                input?.type,
                input?.quantity
            )
        }
    }
    // -------modal-close------------
    const handleClose = () => {
        close()
        setError({})
        setInput({ type: '', quantity: '' });
    }
    // -----------handle-onchange----------------
    const handleChange = (e) => {
        const { name, value } = e.target;
        let newValue = value.replace(/^\s+/, ""); // remove leading space
        if (name === "quantity") {
            newValue = newValue.replace(/\D/g, "");
            setInput({ ...input, [name]: newValue });
        }
        else if (name === "type") {
            setInput({ ...input, [name]: newValue, quantity: '' });
            setError({})
        }
    };


    // ----------add-to-cart-Api---------------------
    const handleAddToCart = async (userId, productId, variantId, itemType, quantity = '') => {
        if (validation()) {
            try {
                // setButtonLoading((prev) => ({ ...prev, [productId]: true }));
                setButtonLoader(true)
                const payload = {
                    userId,
                    productId,
                    variantId,
                    itemType,
                    isAdmin : true,
                    ...(quantity && { quantity }),

                };
                const res = await addToCartApi(payload);
                const { code } = res?.data;
                if (code === 200) {
                    handleClose()
                    listing()
                    fetchMedicineList()
                }
            } catch (error) {
                console.log("Error:", error);
            } finally {
                // setButtonLoading((prev) => ({ ...prev, [productId]: false }));
                setButtonLoader(false)
            }
        }
    };
    return (
        <CustomModal
            className={"add_model"}
            show={show}
            handleClose={handleClose}
        >
            <h3>Medicine Type </h3>
            <div className="form_field">
                <Select
                    type="text"
                    label="Medicine Type"
                    name="type"
                    value={input?.type}
                    onChange={handleChange}
                    error={error.type}
                >
                    <option value="" selected hidden>Select Medicine Type</option>
                    <option value="STRIP">Strip</option>
                    {!data?.billOnlyInStrip && <option value="LOOSE">Loose</option>}
                </Select>
            </div>
            {isLoss && <div className="form_field">
                <Input
                    className={"form-control input"}
                    label='Quantity'
                    type={"text"}
                    name='quantity'
                    value={input.quantity || ""}
                    onChange={handleChange}
                    placeholder="Enter quantity"
                    error={error?.quantity}
                    maxLength={2}
                />
            </div>}

            <div className="button_wrap">
                <button
                    type="button"
                    className="button light"
                    onClick={handleClose}
                >
                    Cancel
                </button>
                <button
                    type="button"
                    ref={buttonLoader}
                    onClick={handleSubmit}
                    className="button"
                >
                    Add
                </button>
            </div>
        </CustomModal>
    )
}

export default MedicineType
